import React from "react";
import { BookOpen, Home, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { createPageUrl } from "../../utils";
import { useLanguage } from "../../i18n";

export default function WelcomeSection() {
  const { t } = useLanguage();
  const cardsContent = t("home.cards", []);
  const cards = [
    {
      icon: Users,
      title: cardsContent[0]?.title,
      text: cardsContent[0]?.text,
    },
    {
      icon: Home,
      title: cardsContent[1]?.title,
      text: cardsContent[1]?.text,
    },
    {
      icon: BookOpen,
      title: cardsContent[2]?.title,
      text: cardsContent[2]?.text,
    },
  ];

  return (
    <section className="py-20 bg-[#f7f1e8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-sm font-semibold tracking-[0.24em] uppercase text-[#C9A227] mb-3">
              {t("home.welcomeEyebrow")}
            </p>
            <h2 className="font-serif-elegant text-3xl sm:text-4xl font-bold text-[#722F37] mb-4 leading-tight">
              {t("home.welcomeTitle")}
            </h2>
            <p className="font-sans-clean text-gray-700 mb-4 leading-relaxed">
              {t("home.welcomeBody1")}
            </p>
            <p className="font-sans-clean text-gray-600 mb-6 leading-relaxed">
              {t("home.welcomeBody2")}
            </p>

            <div className="mb-6 rounded-3xl border border-[#C9A227]/20 bg-white/80 p-5 shadow-sm">
              <p className="font-serif-elegant text-xl text-[#722F37] mb-2">
                {t("home.welcomeAppealTitle")}
              </p>
              <p className="font-sans-clean text-sm leading-relaxed text-gray-700">
                {t("home.welcomeAppealBody")}
              </p>
            </div>

            <div className="flex flex-wrap gap-3">
              <Link
                to={createPageUrl("Donations")}
                className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-[#722F37] text-white font-sans-clean text-sm font-medium hover:bg-[#5A252C] transition-colors"
              >
                {t("home.welcomePrimary")}
              </Link>
              <Link
                to={createPageUrl("Contact")}
                className="inline-flex items-center justify-center px-6 py-3 rounded-lg border border-[#722F37]/20 bg-white text-[#722F37] font-sans-clean text-sm font-medium hover:bg-[#fff7ef] transition-colors"
              >
                {t("home.welcomeSecondary")}
              </Link>
            </div>
          </div>

          <div className="grid sm:grid-cols-3 gap-4">
            {cards.map((item) => (
              <div
                key={item.title}
                className="bg-white rounded-3xl p-6 shadow-sm border border-[#C9A227]/10 text-center"
              >
                <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-[#C9A227]/10 flex items-center justify-center">
                  <item.icon className="w-6 h-6 text-[#C9A227]" />
                </div>
                <h3 className="font-serif-elegant text-lg font-semibold text-[#722F37] mb-2">
                  {item.title}
                </h3>
                <p className="font-sans-clean text-sm text-gray-600">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
